import React from 'react'
import { useFormContext } from 'react-hook-form'
import nextId from 'react-id-generator'
import { useSelector } from 'react-redux'

import { Card } from '@/components/Elements'
import { CreatableSelect, Select } from '@/components/Form'
import { offerQuotationGroupPolicyType } from '@/features/offers/constants/offerEditRights/offerQuotationEditRights'
import { selectOfferPermissions } from '@/features/offers/slices/offerDetail.slice'
import SLAOptions from '@/features/SLAs/constants/SLAOptions'
import { useSLA } from '@/features/SLAs/useSLA'
import { createOptions } from '@/utils/arrayHelper'
import { Select as ChakraSelect, Flex, HStack, Heading, SimpleGrid } from '@chakra-ui/react'

const Equipments = ({ subSystemIndex }) => {
  const offerPermissions = useSelector(selectOfferPermissions)

  const { useFetchAllSLAs } = useSLA()
  const { data: SLAResponse } = useFetchAllSLAs({ page: 1, pageSize: 0 })

  const { setValue } = useFormContext()

  //Translated Variables
  const canEditSubSystem = offerPermissions[offerQuotationGroupPolicyType.QUOTATION_SUB_SYSTEM]?.edit ?? false

  const SLATemplates = Array.isArray(SLAResponse?.data) ? SLAResponse?.data : []
  const templateOptions = createOptions(SLAResponse?.data, 'templateName', 'templateName')

  const handleFillTemplate = (templateName) => {
    const selectedTemplate = SLATemplates.find((template) => template.templateName === templateName)

    console.log('selectedTemplate', selectedTemplate)
    if (!selectedTemplate?.questionnaire) {
      return
    }
    Object.keys(selectedTemplate.questionnaire).forEach((key) => {
      setValue(`subSystems.${subSystemIndex}.SLA.questionnaire.${key}`, selectedTemplate.questionnaire[key], {
        shouldDirty: true,
      })
    })
  }
  return (
    <Card title="EquipmentID & SLA" hasBorder={false}>
      <Flex direction={'column'} gap={2} w="100%">
        <CreatableSelect
          name={`subSystems.${subSystemIndex}.SLA.equipments`}
          label="EquipmentID"
          isRow
          disabled={!canEditSubSystem}
          isRequired
        />

        <HStack>
          <Heading size="md" mb="4" w="100%">
            SLA Template:
          </Heading>
          <ChakraSelect onChange={(e) => handleFillTemplate(e.target.value)} disabled={!canEditSubSystem}>
            <option value=""></option>
            {templateOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </ChakraSelect>
        </HStack>
        <SimpleGrid columns={[2, null, 2]} spacingX="40px" spacingY="15px" my="5">
          {Object.keys(SLAOptions).map((SLASection, sectionIndex) => (
            <Select
              key={nextId('SLAOptions_')}
              label={`${sectionIndex + 1}. ${SLAOptions[SLASection].title}`}
              name={`subSystems.${subSystemIndex}.SLA.questionnaire.${SLASection}`}
              options={SLAOptions[SLASection].options}
              isMulti
              disabled={!canEditSubSystem}
              isRequired={false}
              isRow
            />
          ))}
        </SimpleGrid>
      </Flex>
    </Card>
  )
}

export default Equipments
